﻿// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class StaticRepo {
    static fallBackToolIcon: string;
}
